import { useRequestorStore } from '../../stores/requestorStore';
import TextArea from '../../components/common/TextInputs/TextArea';
import { INSTRUCTION_COMMENT } from '../../utils/constants/text';
import ButtonFilledSmall from '../../components/common/Buttons/ButtonFilledSmall';
import { createFeedback, createHotspot, fetchAllHotspotData, getFeedback } from '../../utils/api/feedbackApi';
import { useCommonStore } from '../../stores/commonStore';
import ImageViewer from '../../components/common/ImageViewer';
import ChatThread from '../../components/common/ChatThread';
import { useEffect, useState } from 'react';
import { FeedBackInfo } from '../../types/requester';
import { getTimeDiff } from '../../utils/commonUtils';
import { useVendorStore } from '../../stores/vendorStore';
import { Messages, MessageType, Units } from '../../utils/enums';
import { captureRotationConfig, updateViewer } from '../hotspotUtils/ViewerConfig';
import { IFrameRefHandler } from './IFrameRefHandler';

interface QueryParams {
    id: string;
}

const ProductsDetails = () => {
    const activeProduct = useRequestorStore((state) => state.activeProduct);
    const setFeedback = useRequestorStore((state) => state.setFeedback);
    const feedback: Array<FeedBackInfo> | null = useRequestorStore((state) => state.feedback);
    const setToastMessage = useCommonStore((state) => state.setToastMessage);
    const setFlyoutRightOpen = useCommonStore((state) => state.setFlyoutRightOpen);
    const setProductFlagged = useCommonStore((state) => state.setProductFlagged);
    const showComments = useVendorStore((state) => state.showComments);
    const alwaysHideFeedback = useCommonStore((state) => state.alwaysHideFeedback);
    const [feedbackMessage, setFeedbackMessage] = useState('');
    const width = activeProduct?.productSize?.width?.value || '';
    const depth = activeProduct?.productSize?.depth?.value || '';
    const height = activeProduct?.productSize?.height?.value || '';
    const width3D: number | undefined = activeProduct?.modelSize3D?.width3D;
    const depth3D: number | undefined = activeProduct?.modelSize3D?.depth3D;
    const height3D: number | undefined = activeProduct?.modelSize3D?.height3D;
    const unit: Units | undefined = activeProduct?.modelSize3D?.unit;
    const dimensions3D: string = `${width3D} X ${depth3D} X ${height3D} ${unit}`;
    const hotspotCreationFlag = useCommonStore((state) => state.isHotspotCreationActive);
    const coordinates = useCommonStore((state) => state.hotspotCoordinates);
    const setHotspot = useCommonStore((state) => state.setHotspotCoordinate);
    const activeHotspot = useCommonStore((state) => state.activeHostpot);
    const setHotspotCreation = useCommonStore((state) => state.setHotspotCreation);

    useEffect(() => {
        if (activeProduct?.fsn) {
            showFeedbacks();
        }
    }, [activeProduct?.fsn]);

    const showFeedbacks = async () => {
        const feedbackResponse = await getFeedback(activeProduct?.fsn);
        setFeedback(feedbackResponse.data);
    };

    const handleSendFeedback = async () => {
        const data = {
            product: activeProduct?.fsn,
            comment: feedbackMessage
        };
        const check_empty = new RegExp('^[\\s]*$');
        if (!check_empty.test(data.comment)) {
            if (hotspotCreationFlag) {
                let response = await createHotspot(data.product as string, { ...coordinates, comment: data.comment });
                let cmd = updateViewer(coordinates, data.product as string, Object.keys(response.data.hotspotCardMap)[0]);
                const iFrameRef = IFrameRefHandler.getInstance('');
                iFrameRef.postMessage(cmd);
                setToastMessage({ type: MessageType.SUCCESS, message: Messages.HOTSPOT_CREATED });
                setHotspotCreation(false);
            } else {
                await createFeedback(data);
                setToastMessage({ type: MessageType.SUCCESS, message: Messages.FEEDBACK_CREATED });
            }
            const feedbackResponse = await getFeedback(activeProduct?.fsn);
            setFeedback(feedbackResponse.data);
            setFeedbackMessage('');
            setFlyoutRightOpen(false);
            setProductFlagged(true);
            setHotspot(false);
        }
    };

    const onFeedbackChange = (event) => {
        const value = event.target.value;
        setFeedbackMessage(value);
    };

    const sendCaptureCommmand = () => {
        let cmd = captureRotationConfig();
        const iFrameRef = IFrameRefHandler.getInstance('');
        iFrameRef.postMessage(cmd);
    };

    if (showComments == true) {
        return (
            <div className="flex-column  h-full p-8 overflow-scroll">
                <h1 className="text-xl font-semibold text-black mb-6">MY Comments</h1>
                <button
                    onClick={sendCaptureCommmand}
                    type="button"
                    className={`py-2 px-4 bg-transparent border whitespace-nowrap transition ease-in duration-200 text-center text-base font-semibold focus:outline-none rounded-md
            ${100 ? ' w-full' : ''} ${' border-blue-600 text-blue-600'}`}
                ></button>
                <>
                    <div className="mb-10">
                        {feedback?.map((feed: FeedBackInfo) => {
                            let highlightFlag: boolean = true;
                            if (activeHotspot.length > 0) {
                                if (feed.hotspot !== null && activeHotspot === feed.hotspot.hotspotId.toString()) highlightFlag = false;
                            } else highlightFlag = feed.isResolved ? true : false;
                            let timeDiff = getTimeDiff(feed.updatedAt, new Date());
                            return (
                                <ChatThread
                                    key={feed.feedbackId}
                                    isResolved={feed.isResolved ? true : false}
                                    name={feed.user.username}
                                    dateAndtime={timeDiff.toString()}
                                    text={feed.comment}
                                    isHighlighted={highlightFlag}
                                    feedbackId={feed.feedbackId}
                                    hotspotId={feed?.hotspot?.hotspotId ? feed?.hotspot?.hotspotId : ''}
                                />
                            );
                        })}
                    </div>
                    <div className="pb-5 px-1">
                        <TextArea placeholder={INSTRUCTION_COMMENT} onChange={onFeedbackChange} value={feedbackMessage} />
                        <div className="w-44 ml-auto mt-3">
                            <ButtonFilledSmall fullWidth label="Send" onClick={handleSendFeedback} />
                        </div>
                    </div>
                </>
            </div>
        );
    } else {
        return (
            <div className="h-full p-8 overflow-scroll">
                <h1 className="text-xl font-semibold text-black mb-6">{activeProduct?.fsn}</h1>
                <div className="h-full">
                    <div className="mb-10">
                        <h1 className="text-gray-900 whitespace-no-wrap text-base uppercase mb-4">images</h1>
                        <div className="flex gap-4 flex-wrap">
                            <ImageViewer images={activeProduct?.productImages} />
                        </div>
                    </div>
                    <div className="mb-10">
                        <h1 className="text-gray-900 whitespace-no-wrap text-base uppercase mb-4">Dimensions</h1>
                        <div className="flex flex-wrap">
                            {activeProduct?.productSize && (
                                <div className="mr-8 mb-3">
                                    <div className="text-gray-500 whitespace-no-wrap text-base mb-2">W x D x H</div>
                                    <div className="text-gray-900 whitespace-no-wrap text-base capitalize">
                                        {width} X {depth} X {height}
                                        <span className="lowercase"> {activeProduct?.productSize?.width?.qualifier}</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mb-10">
                        {activeProduct?.modelSize3D && (
                            <>
                                <h1 className="text-gray-900 whitespace-no-wrap text-base uppercase mb-4">Dimensions of 3D Model</h1>
                                <div className="flex flex-wrap">
                                    <div className="mr-8 mb-3">
                                        <div className="text-gray-500 whitespace-no-wrap text-base mb-2">W x D x H</div>
                                        <div className="text-gray-900 whitespace-no-wrap text-base">{dimensions3D}</div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                    {!alwaysHideFeedback && (
                        <div className="pb-5 px-1">
                            <TextArea placeholder={INSTRUCTION_COMMENT} onChange={onFeedbackChange} value={feedbackMessage} />
                            <div className="w-44 ml-auto mt-3">
                                <ButtonFilledSmall fullWidth label="Send" onClick={handleSendFeedback} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
};

export default ProductsDetails;
